<template>
  <div v-editable="blok">
    <div class="page-mx module-pt module-pb grid">
      <div
        class="flex flex-col items-center clamp-gap-8-12 tl:flex-row tl:items-start tl:items-end">
        <ElementTexts
          v-if="blok.texts?.length"
          :bloks="blok.texts"
          :textPosition="!isTL ? 'left' : 'center'" />
        <ALink :to="blok.buttonLink" class="shrink-0">
          <AButton :text="blok.buttonLabel" />
        </ALink>
      </div>
      <div>
        <div
          v-if="state != 'ERROR'"
          class="grid grid-cols-12 clamp-gap-5-5 clamp-mt-8-12">
          <div
            v-if="state === 'LOADING'"
            v-for="post in 4"
            class="col-span-12 ml:col-span-6 tl:col-span-3 group">
            <div class="overflow-hidden card-rounded">
              <div
                class="w-full relative aspect-1 bg-skeleton skeleton-loading-image effect-hover-tilt-media"></div>
            </div>
          </div>
          <ALink
            v-if="state === 'RESULTS'"
            v-for="post in posts"
            :to="{ url: post.url, linktype: 'url', target: '_blank' }"
            class="col-span-12 ml:col-span-6 tl:col-span-3 group">
            <div class="overflow-hidden card-rounded">
              <div
                class="w-full relative aspect-1 bg-skeleton skeleton-loading-image effect-hover-tilt-media">
                <img
                  v-if="post.image"
                  :src="post.image"
                  :alt="post.text"
                  :width="1024"
                  :height="1024"
                  class="w-full object-cover h-full"
                  loading="lazy"
                  @load="imgLoaded = true" />
              </div>
            </div>
          </ALink>
        </div>
        <div
          v-if="state === 'ERROR'"
          class="w-full flex flex-col items-center clamp-mt-8-12">
          <ElementErrorNoResults :blok="blok.errorNoResults[0]" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ModuleSocialMediaFeedStoryblok } from "@/types";
import { getBreakpoint } from "@/../uno-preset/preset-theme";
import useSocialMediaPosts from "@/composables/useSocialMediaFeeds";

interface Props {
  blok: ModuleSocialMediaFeedStoryblok;
}
const props = defineProps<Props>();

const { posts, fetchPosts, state } = useSocialMediaPosts();
const isTL = ref(true);
const imgLoaded = ref(false);

function onRezise() {
  isTL.value = window.innerWidth < getBreakpoint("tl");
}

onMounted(() => {
  onRezise();
  window.addEventListener("resize", onRezise);
  fetchPosts(props.blok.feedPublicKey);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", onRezise);
});
</script>

<style scoped lang="scss"></style>
